import { useNavigation } from 'react-router'

/**
 * Returns true if the page is loading due to a navigation event.
 * Replaces the Next.js router.events-based implementation.
 */
const useNavigationLoading = () => {
  const navigation = useNavigation()
  return navigation.state === 'loading'
}

export default useNavigationLoading
